export const set_region = (payload) => ({
  type: 'SET_REGION',
  payload
});

export const set_language = (payload) => ({
  type: 'SET_LANGUAGE',
  payload
});

export const set_country = (payload) => ({
  type: 'SET_COUNTRY',
  payload
});
